// Configurações do Supabase
export const SUPABASE_CONFIG = {
    url: 'https://wczvabjpgumwcszpifmv.supabase.co',
    anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndjenZhYmpwZ3Vtd2NzenBpZm12Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk5MDUwNDMsImV4cCI6MjA2NTQ4MTA0M30.QXJ2iIRfWSwpj6Vk7U9rgvUELkiJZwb4ite5aYMm7SI',
    projectId: 'wczvabjpgumwcszpifmv'
};

// Configurações de Storage
export const STORAGE_CONFIG = {
    buckets: {
        uploads: 'uploads',
        avatars: 'avatars',
        documents: 'documents',
        chatFiles: 'chat-files'
    },
    maxFileSizes: {
        avatar: 5 * 1024 * 1024, // 5MB
        upload: 50 * 1024 * 1024, // 50MB
        document: 100 * 1024 * 1024 // 100MB
    },
    allowedTypes: {
        images: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
        documents: [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/plain'
        ]
    }
};

// Configurações de tabelas
export const TABLES = {
    companies: 'companies',
    userProfiles: 'user_profiles',
    clients: 'clients',
    projects: 'projects',
    projectTasks: 'project_tasks',
    tickets: 'tickets',
    ticketComments: 'ticket_comments',
    knowledgeBase: 'knowledge_base',
    systems: 'systems',
    systemVersions: 'system_versions',
    companySystem: 'company_systems',
    invoices: 'invoices',
    payments: 'payments',
    userMessages: 'user_messages',
    userFavorites: 'user_favorites',
    userNotifications: 'user_notifications',
    userCalendarEvents: 'user_calendar_events',
    timesheetEntries: 'timesheet_entries',
    chatMessages: 'chat_messages',
    auditLogs: 'audit_logs'
};

// Configurações de status
export const STATUS_OPTIONS = {
    tickets: {
        open: 'Aberto',
        in_progress: 'Em Progresso',
        pending: 'Pendente',
        resolved: 'Resolvido',
        closed: 'Fechado',
        cancelled: 'Cancelado'
    },
    projects: {
        planning: 'Planejamento',
        active: 'Ativo',
        on_hold: 'Em Espera',
        completed: 'Concluído',
        cancelled: 'Cancelado'
    },
    invoices: {
        draft: 'Rascunho',
        pending: 'Pendente',
        paid: 'Pago',
        overdue: 'Vencido',
        cancelled: 'Cancelado'
    },
    clients: {
        active: 'Ativo',
        inactive: 'Inativo',
        suspended: 'Suspenso'
    }
};

// Configurações de prioridade
export const PRIORITY_OPTIONS = {
    low: 'Baixa',
    normal: 'Normal',
    high: 'Alta',
    urgent: 'Urgente',
    critical: 'Crítica'
};

// Configurações de tipos
export const TYPE_OPTIONS = {
    tickets: {
        issue: 'Problema',
        request: 'Solicitação',
        task: 'Tarefa',
        bug: 'Bug',
        feature: 'Funcionalidade',
        support: 'Suporte'
    },
    notifications: {
        info: 'Informação',
        success: 'Sucesso',
        warning: 'Aviso',
        error: 'Erro'
    }
};

// Configurações de roles/papéis
export const ROLES = {
    admin: 'Administrador',
    manager: 'Gerente',
    agent: 'Agente',
    user: 'Usuário',
    client: 'Cliente'
};

// Configurações de realtime
export const REALTIME_CONFIG = {
    channels: {
        tickets: 'public:tickets',
        chat: 'public:chat_messages',
        notifications: 'public:user_notifications'
    }
};

// Configurações de paginação
export const PAGINATION = {
    defaultLimit: 20,
    maxLimit: 100,
    defaultOffset: 0
};

// Configurações de formato de data
export const DATE_FORMATS = {
    display: 'dd/MM/yyyy',
    displayWithTime: 'dd/MM/yyyy HH:mm',
    api: 'yyyy-MM-dd',
    apiWithTime: 'yyyy-MM-dd HH:mm:ss'
}; 